import BaseCircleIcon from 'components/BaseCircleIcon';
import CircleIcon from 'components/CircleIcon';
import SectionLabel from 'components/typography/SectionLabel';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';

export default function SectionLabelWithIcon({
  iconClassName = 'text-xl',
  iconContainerClassName = '',
  sectionClassName = '',
  label = '',
  icon = null,
  className = '',
  isPdf = false,
  style = {},
}) {
  return (
    <div
      className={className}
      style={{ display: 'flex', alignItems: 'center', gap: '1rem', ...style }}
    >
      {isPdf ? (
        <BaseCircleIcon
          className={`${iconContainerClassName} mt-1`}
          iconClassName={iconClassName}
          style={{ backgroundColor: DEFAULT_SECONDARY_COLOUR }}
        >
          {icon}
        </BaseCircleIcon>
      ) : (
        <CircleIcon
          className={`${iconContainerClassName} mt-1`}
          iconClassName={iconClassName}
        >
          {icon}
        </CircleIcon>
      )}
      <SectionLabel label={label} className={sectionClassName} />
    </div>
  );
}
